import { useAuth0 } from '@auth0/auth0-react';
import { useCookies } from 'react-cookie';
import { CloudFrontCookiesKey, GcpCdnCookiesKey } from '@/types';
import { useState } from 'react';

export const useAuthService = () => {
  const cloudFrontCookieNames = Object.values(CloudFrontCookiesKey);
  const gcpCdnCookieNames = Object.values(GcpCdnCookiesKey);
  const allCookieNames = [...cloudFrontCookieNames, ...gcpCdnCookieNames];
  const [, , removeCookie] = useCookies(allCookieNames);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const { logout, user, isAuthenticated } = useAuth0();

  const handleLogout = async () => {
    setIsLoggingOut(true);
    // Clear all CDN cookies (both CloudFront and GCP CDN)
    for (const cookieName of allCookieNames) {
      removeCookie(cookieName, { path: '/', domain: '.abyssfabric.co' });
    }
    // Nothing After logout() will work, since it redirects away from this page after logout is performed.
    // auth0 logout will allways redirect to the URL specified in the returnTo parameter or just automatically go to window.location.origin
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return { handleLogout, user, isAuthenticated, isLoggingOut };
};
